import { ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { navbarCloseMobile, selectFuseNavbar } from '@/components/theme-layouts/components/navbar/navbarSlice';
import usePathname from '@fuse/hooks/usePathname';
import useFuseLayoutSettings from '@fuse/core/FuseLayout/useFuseLayoutSettings';
import { useNavbarTheme } from '@fuse/core/FuseSettings/hooks/fuseThemeHooks';
import NavbarToggleFabLayout1 from './NavbarToggleFabLayout1';
import NavbarStyle2 from './navbar/style-2/NavbarStyle2';

/**
 * The navbar wrapper layout 1.
 * Simplified to only use NavbarStyle2
 */
function NavbarWrapperLayout1() {
	const { config } = useFuseLayoutSettings();

	const navbar = useAppSelector(selectFuseNavbar);
	const pathname = usePathname();

	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (isMobile) {
			dispatch(navbarCloseMobile());
		}
	}, [dispatch, pathname, isMobile]);

	const navbarTheme = useNavbarTheme();

	return (
		<>
			<ThemeProvider theme={navbarTheme}>
				<NavbarStyle2 />
			</ThemeProvider>
			{config?.navbar?.display && !config?.toolbar?.display && !navbar.open && <NavbarToggleFabLayout1 />}
		</>
	);
}

export default NavbarWrapperLayout1;
